module.exports = __webpack_public_path__ + "static/media/american-flag.dc797c10.svg";